import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { ShipmentDraftsApi } from "@freightsimple/generated-dashboard-openapi-client/apis/ShipmentDraftsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useShipmentDraftsApi(): ShipmentDraftsApi {
  const { accessToken } = useAuthentication();

  return new ShipmentDraftsApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
